<script setup>
    import {onMounted, ref, watch} from "vue";

    import {ModalsContainer, useModal, useVfm} from 'vue-final-modal'
    import Modal from "@component/Modal/Modal.vue";
    import {getCookie, removeCookie, setCookie} from "@util/cookies";
    import {apiFetch} from "@util/api";

    const vfm = useVfm();
    const showModal = ref(false)
    const {
        popupContent,
        popupButtonText,
        popupCountryBypass,
    } = POPUP;
    const {zipcodeApi} = API
    const {userIp} = LOC;
    const cookieName = 'country-popup-dismissed';
    const modalId = 'out-of-country-modal'

    let userCountryCookie = getCookie(cookieName);
    const cookieParams = {
        outOfCountry: false,
        popupDismissed: true,
    }

    /**
     * Makes a call to via API to check the user's
     * country based on their IP address, and sets
     * a cookie if they are out of country or not
     *
     * @returns {Promise<void>}
     */
    const showPopup = async () => await apiFetch(zipcodeApi, {userIp})
        .then(({status, data}) => {
            if (status === 200) {
                const hidePopup = popupCountryBypass.includes(data.country_name)

                Object.assign(cookieParams, {
                    outOfCountry: !hidePopup,
                    popupDismissed: hidePopup
                });
                setCookie(cookieName, cookieParams)

                !hidePopup && open()
            }
        })

    /**
     * Checks the browser cookies again to see if we should show the modal or not
     */
    const checkPopup = () => {
        const userCountryCookie = getCookie(cookieName);
        let popupDismissed = false;
        if (userCountryCookie) {
            popupDismissed = userCountryCookie?.popupDismissed;
        }


        // If the user somehow bypassed the modal,
        // we'll show it the next page load
        !popupDismissed && open()
    }

    /**
     * Modal Setup
     */
    const {open, close} = useModal({
        component: Modal,
        attrs: {
            clickToClose: true,
            escToClose: true,
            focusTrap: true,

            content: popupContent,
            confirmText: popupButtonText,

            modalId,

            onConfirm() {
                setCookie(cookieName,
                    {
                        outOfCountry: true,
                        popupDismissed: true,
                    }
                )
                close()
            },
            onDeny() {
                /**
                 * Set the cookie in case somehow
                 * the user dismisses the popup
                 */
                setCookie(cookieName,
                    {
                        outOfCountry: true,
                        popupDismissed: false,
                    }
                )
                close()
            }
        },
    })

   onMounted(() => {
       /**
        * Check if the cookie set for the dismissed popup isn't an object
        */
       if (userCountryCookie && typeof userCountryCookie !== 'object') {
           userCountryCookie = undefined;
           removeCookie(cookieName)
       }

       /**
        * If the cookie isn't here, we'll run through showing
        * the popup if the users IP shows it's out of country
        */
       if (userCountryCookie === undefined) showPopup()
           .finally(() => checkPopup())
       else checkPopup()
   })

</script>

<template>
    <ModalsContainer />
</template>

<script>
    export default {
        name: "Out Of Country Modal"
    }
</script>

<style lang="scss" scoped>

</style>
